/**
 * Kundenportal Api
 * Kundenportal Api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NotificationPayload } from './notificationPayload';


export interface NotificationDto { 
    id: number;
    partnernummer: string;
    paxEventTypeId: NotificationDto.PaxEventTypeIdEnum;
    notified: boolean;
    read: boolean;
    created: string;
    policennummer?: string;
    payload?: NotificationPayload;
}
export namespace NotificationDto {
    export type PaxEventTypeIdEnum = 'police_expiration' | 'police_expiration_reminder' | 'data_update' | 'new_document' | 'new_chat_message' | 'new_doc_police' | 'new_doc_steuerbescheinigung' | 'praemienrechnung' | 'zahlungserinnerung' | 'postal_return' | 'mahnung' | 'data_update_first_reminder' | 'data_update_second_reminder' | 'invalid_document';
    export const PaxEventTypeIdEnum = {
        POLICE_EXPIRATION: 'police_expiration' as PaxEventTypeIdEnum,
        POLICE_EXPIRATION_REMINDER: 'police_expiration_reminder' as PaxEventTypeIdEnum,
        DATA_UPDATE: 'data_update' as PaxEventTypeIdEnum,
        NEW_DOCUMENT: 'new_document' as PaxEventTypeIdEnum,
        NEW_CHAT_MESSAGE: 'new_chat_message' as PaxEventTypeIdEnum,
        NEW_DOC_POLICE: 'new_doc_police' as PaxEventTypeIdEnum,
        NEW_DOC_STEUERBESCHEINIGUNG: 'new_doc_steuerbescheinigung' as PaxEventTypeIdEnum,
        PRAEMIENRECHNUNG: 'praemienrechnung' as PaxEventTypeIdEnum,
        ZAHLUNGSERINNERUNG: 'zahlungserinnerung' as PaxEventTypeIdEnum,
        POSTAL_RETURN: 'postal_return' as PaxEventTypeIdEnum,
        MAHNUNG: 'mahnung' as PaxEventTypeIdEnum,
        DATA_UPDATE_FIRST_REMINDER: 'data_update_first_reminder' as PaxEventTypeIdEnum,
        DATA_UPDATE_SECOND_REMINDER: 'data_update_second_reminder' as PaxEventTypeIdEnum,
        INVALID_DOCUMENT: 'invalid_document' as PaxEventTypeIdEnum
    };
}


